import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Paper } from '@mui/material';
import withRouter from 'react-router-dom/withRouter';
import { useStyles } from './searchbar.styles';
import { useDispatch, useSelector } from 'react-redux';
import { get, set } from 'global/lib/lodash';
import setFilter from 'redux/actions/setFilter';
import { useScreen } from 'global/styles';
import { setBodyOverflow } from 'global/hooks/useBodyOverflow';

const SortSelect = (props) => {
  const { options } = props;
  const dispatch = useDispatch();
  const split = get(props, 'location.pathname', '')
    .split('/')
    .filter((s) => s);
  const filter = useSelector((state) => get(state, ['filter', ...split]));
  const [selected, setSelected] = useState(get(filter, '_sort.sortBy', 0));
  const { isMobile } = useScreen();
  const classes = useStyles({ isMobile });

  const handleSelect = (e) => {
    const val = e.target.value;
    setSelected(val);
    if (filter) {
      dispatch(setFilter(split[0], split[1], set({ ...filter }, '_sort.sortBy', val)));
    }
    setBodyOverflow();
  };

  const sortBy = get(filter, '_sort.sortBy');

  useEffect(() => {
    setSelected(sortBy);
  }, [sortBy]);

  const showNone = get(props, 'showNone', true);

  return (
    <Paper className={classes.sortContainer}>
      <FormControl className={classes.sortForm} variant='standard'>
        <InputLabel htmlFor="Standard-sort">Sort By</InputLabel>
        <Select value={selected} onChange={handleSelect} className={classes.select} disableUnderline>
          {showNone && (
            <MenuItem key={'_none_'} value={undefined}>
              {'None'}
            </MenuItem>
          )}
          {(options || []).map((opt, i) => (
            <MenuItem key={i} value={opt.value || i}>
              {opt.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Paper>
  );
};

export const Sort = withRouter(SortSelect);
